<template>
  <div>
    <el-select
      :value="value"
      aria-label="Special Labels"
      multiple
      filterable
      :multiple-limit="20"
      :loading="loading"
      :disabled="!!error"
      placeholder="Select special labels"
      style="width: 100%"
      @input="$emit('input', $event)"
    >
      <el-option
        v-for="label in options"
        :key="label.id"
        :label="label.name"
        :value="label.id"
        ><span>{{ label.name }}</span></el-option
      >
    </el-select>
    <p v-if="error" role="alert">{{ error }}</p>
    <el-button type="text" :loading="loading" @click="load"
      >Refresh available labels</el-button
    >
    <p style="font-size: 12px; color: #606266">
      Choose up to 20 labels. They appear in selection order on the collection
      page and cards. Labels are managed by the platform admin.
    </p>
    <CollectionSpecialLabels :labels="selected" details />
  </div>
</template>
<script>
import { postRequest } from '@/apis/front';
import CollectionSpecialLabels from './CollectionSpecialLabels.vue';
export default {
  components: { CollectionSpecialLabels },
  props: { value: { type: Array, default: () => [] } },
  data: () => ({ options: [], loading: false, error: '' }),
  computed: {
    selected() {
      return this.value
        .map((id) => this.options.find((label) => label.id === id))
        .filter(Boolean);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const res = await postRequest('listCollectionSpecialLabels', {});
        if (res.data.code !== 0) throw new Error(res.data.msg);
        this.options = res.data.data || [];
      } catch (e) {
        this.error = e.message || 'Could not load labels. Please retry.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
